import {
    LATEST_PRO_PLUS_RATE,
    LATEST_PRO_RATE,
    LATEST_START_RATE,
} from 'services/billing/constants';
import { t } from 'ttag';

import { AccountRate, RateStatus } from '../../services/enums';
import { CompanyRate } from '../../types/billing';

import {
    ARCHIVE_BIG_PRICE,
    ARCHIVE_SMALL_PRICE,
    INTEGRATION_FOP_PRICE_YEARLY,
    INTEGRATION_PRICE_YEARLY,
    PRO_FOP_PRICE,
    PRO_OLD,
    PRO_TOV_PRICE,
    START_FOP_PRICE,
    START_PRICE,
    TRIAL_PRICE,
} from '../../lib/constants';
import { ACCOUNT_RATE_TITLE_MAP } from '../../services/billing';

export const NEW_PLAN_ID = 'newPlanId';

export const RATE_TYPE_DROPDOWN_OPTIONS = [
    {
        label: ACCOUNT_RATE_TITLE_MAP[AccountRate.INTEGRATION],
        value: AccountRate.INTEGRATION,
    },
    {
        label: ACCOUNT_RATE_TITLE_MAP[LATEST_START_RATE],
        value: LATEST_START_RATE,
    },
    {
        label: ACCOUNT_RATE_TITLE_MAP[LATEST_PRO_RATE],
        value: LATEST_PRO_RATE,
    },
    {
        label: ACCOUNT_RATE_TITLE_MAP[LATEST_PRO_PLUS_RATE],
        value: LATEST_PRO_PLUS_RATE,
    },
    {
        label: ACCOUNT_RATE_TITLE_MAP[AccountRate.PRO],
        value: AccountRate.PRO,
    },
    {
        label: ACCOUNT_RATE_TITLE_MAP[AccountRate.ULTIMATE_2022_12],
        value: AccountRate.ULTIMATE_2022_12,
    },
    {
        label: ACCOUNT_RATE_TITLE_MAP[AccountRate.INTEGRATION_TRIAL],
        value: AccountRate.INTEGRATION_TRIAL,
    },
    {
        label: ACCOUNT_RATE_TITLE_MAP[AccountRate.PRO_PLUS_TRIAL_2022_12],
        value: AccountRate.PRO_PLUS_TRIAL_2022_12,
    },
    {
        label: ACCOUNT_RATE_TITLE_MAP[AccountRate.ARCHIVE_SMALL],
        value: AccountRate.ARCHIVE_SMALL,
    },
    {
        label: ACCOUNT_RATE_TITLE_MAP[AccountRate.ARCHIVE_BIG],
        value: AccountRate.ARCHIVE_BIG,
    },
];

export const RATE_PRICES_MAP: Partial<Record<AccountRate, string>> = {
    [AccountRate.INTEGRATION]: String(INTEGRATION_PRICE_YEARLY),
    [`${AccountRate.INTEGRATION}_fop`]: String(INTEGRATION_FOP_PRICE_YEARLY),
    [LATEST_START_RATE]: String(START_PRICE),
    [`${LATEST_START_RATE}_fop`]: String(START_FOP_PRICE),
    [LATEST_PRO_RATE]: String(PRO_TOV_PRICE),
    [`${LATEST_PRO_RATE}_fop`]: String(PRO_FOP_PRICE),
    [LATEST_PRO_PLUS_RATE]: String(TRIAL_PRICE),
    [AccountRate.PRO]: String(PRO_OLD),
    [AccountRate.ARCHIVE_SMALL]: String(ARCHIVE_SMALL_PRICE),
    [AccountRate.ARCHIVE_BIG]: String(ARCHIVE_BIG_PRICE),
};

export const RATE_STATUS_NAMES_MAP = {
    [RateStatus.ACTIVE]: t`Активний`,
    [RateStatus.NEW]: t`Запланований`,
    [RateStatus.CANCELED]: t`Відмінений`,
    [RateStatus.EXPIRED]: t`Прострочений`,
};

export const DEFAULT_RATE: CompanyRate = {
    id: 'default',
    rate: AccountRate.FREE,
    status: RateStatus.ACTIVE,
    startDate: '',
    endDate: '',
    amount: null,
    config: {},
};

export const NEW_RATE: CompanyRate = {
    id: NEW_PLAN_ID,
    rate: AccountRate.INTEGRATION,
    status: RateStatus.NEW,
    startDate: '',
    endDate: '',
    amount: null,
    config: {},
};

export const EDITABLE_RATES = [
    AccountRate.OLD,
    AccountRate.INTEGRATION,
    AccountRate.PRO,
    AccountRate.PRO_TRIAL,
    AccountRate.START,
    AccountRate.START_2022_01,
    AccountRate.START_2022_04,
    AccountRate.START_2022_08,
    AccountRate.START_2023_10,
    AccountRate.START_2024_10,
    AccountRate.PRO_2021,
    AccountRate.PRO_2022,
    AccountRate.PRO_2022_01,
    AccountRate.PRO_2022_04,
    AccountRate.PRO_2022_12,
    AccountRate.PRO_2023_07,
    AccountRate.PRO_2023_10,
    AccountRate.PRO_2024_10,
    AccountRate.PRO_PLUS,
    AccountRate.PRO_PLUS_2022_04,
    AccountRate.PRO_PLUS_2022_12,
    AccountRate.ULTIMATE,
    AccountRate.ULTIMATE_2022_12,
    AccountRate.INTEGRATION_TRIAL,
    AccountRate.PRO_PLUS_TRIAL_2022,
    AccountRate.PRO_PLUS_TRIAL_2022_12,
    AccountRate.ARCHIVE_SMALL,
    AccountRate.ARCHIVE_BIG,
];

interface FilterButton {
    title: string;
    statuses: RateStatus[];
}

export const FINISHED_RATES_STATUSES = [
    RateStatus.EXPIRED,
    RateStatus.CANCELED,
];

export const ACTIVE_RATES_STATUSES = [RateStatus.ACTIVE, RateStatus.NEW];

export const FILTER_RATES_BUTTONS: FilterButton[] = [
    {
        title: t`Активні`,
        statuses: ACTIVE_RATES_STATUSES,
    },
    {
        title: t`Завершені`,
        statuses: FINISHED_RATES_STATUSES,
    },
] as const;

export const trialWebOrApiRates: AccountRate[] = [
    AccountRate.INTEGRATION_TRIAL,
    AccountRate.PRO_PLUS_TRIAL_2022,
    AccountRate.PRO_PLUS_TRIAL_2022_12,
] as const;

export const INFINITY_SIGN_RATES: AccountRate[] = [
    AccountRate.ULTIMATE,
    AccountRate.ULTIMATE_2022_12,
    AccountRate.PRO_PLUS,
    AccountRate.PRO_PLUS_2022_04,
    AccountRate.PRO_PLUS_2022_12,
    AccountRate.PRO,
] as const;

export const DASH_SIGN_RATES: AccountRate[] = [
    AccountRate.PRO_PLUS_TRIAL,
    AccountRate.PRO_PLUS_TRIAL_2022,
    AccountRate.PRO_PLUS_TRIAL_2022_12,
    AccountRate.INTEGRATION,
    AccountRate.INTEGRATION_TRIAL,
    AccountRate.ARCHIVE_BIG,
    AccountRate.ARCHIVE_SMALL,
] as const;
